module.exports = __webpack_public_path__ + "media/images/ic-checked-ebc0edf888d9c4eb463a2f92e912e6fd.png";